import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import MediaUpload from '../../../components/Business/MediaUpload'
import SettingsCard from '../../../components/Settings/SettingsCard'

const COVER_PHOTO_DIMENSIONS = '1920x600'

export default function CoverPhotoCard({
  imageUrl,
  onChange,
  onSave,
  hasChanged,
  isSaving,
}) {
  const { t } = useTranslation()

  return (
    <SettingsCard
      icon="camera"
      title={t('business.edit.cover_photo_title', 'Business Page Cover Photo')}
      actions={
        <button
          className="btn btn-primary"
          type="button"
          onClick={onSave}
          disabled={!hasChanged || isSaving}
        >
          {isSaving
            ? t('users.edit.saving', 'Saving...')
            : t('business.edit.save')}
        </button>
      }
    >
      <MediaUpload
        imageUrl={imageUrl}
        onChange={onChange}
        label={t(
          'business.edit.cover_photo_label',
          'Business Page Cover Photo',
        )}
        dimensions={COVER_PHOTO_DIMENSIONS}
      />
    </SettingsCard>
  )
}

CoverPhotoCard.propTypes = {
  imageUrl: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  hasChanged: PropTypes.bool,
  isSaving: PropTypes.bool,
}
